"use client";

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export interface FAQ {
  question: string;
  answer: string;
}

interface PropertyFAQsProps {
  faqs: FAQ[];
}

export function PropertyFAQs({ faqs }: PropertyFAQsProps) {
  const defaultFaqs: FAQ[] = [
    {
      question: "What is Masterkey?",
      answer:
        "Masterkey is your AI co-pilot for real estate. We provide powerful tools to analyze properties with unparalleled depth, intelligently organize your search and transaction details, and reimagine a space's potential—all powered by cutting-edge AI. Our AI Property Analysis is just the beginning of how we put you in control of your real estate journey.",
    },
    {
      question: "What else can I do with Masterkey beyond property analysis?",
      answer:
        "Beyond analyzing properties with AI-powered insights, you can organize your entire home buying journey in our centralized platform and reimagine spaces with AI visualization before purchasing. Our platform helps you store documents with AI summaries, track properties with notes, manage tasks, and connect with top-rated professionals when you need specific expertise.",
    },
  ];

  return (
    <section id="property-faqs" className="space-y-4">
      <h2 className="text-2xl font-semibold">Frequently Asked Questions</h2>
      <div className="space-y-4">
        <Accordion type="single" collapsible className="w-full">
          {defaultFaqs.map((faq, index) => (
            <AccordionItem
              key={faq.question}
              value={`default-${index}`}
              className="border-b"
            >
              <AccordionTrigger className="text-left font-bold hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
          {faqs?.map((faq, index) => (
            <AccordionItem
              key={faq.question}
              value={`item-${index}`}
              className="border-b"
            >
              <AccordionTrigger className="text-left font-bold hover:no-underline">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
